import { render, staticRenderFns } from "./ManualVideoLink.vue?vue&type=template&id=cdbaf450&scoped=true&"
import script from "./ManualVideoLink.vue?vue&type=script&lang=js&"
export * from "./ManualVideoLink.vue?vue&type=script&lang=js&"
import style0 from "./ManualVideoLink.vue?vue&type=style&index=0&id=cdbaf450&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbaf450",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
